/* eslint-disable react/jsx-no-bind */
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  HStack,
  Text,
} from "@chakra-ui/react";
import { FC, useRef } from "react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  moduleName: string;
  onConfirm: () => void;
};

export const ModuleDeleteModal: FC<Props> = ({
  isOpen,
  onClose,
  moduleName,
  onConfirm,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            モジュール削除
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text>
              「{moduleName}」を次の一括公開まで「削除候補」にしますか？
            </Text>
            <Text mt="8px" fontSize="sm" color="gray.600">
              一括公開するまで本番のタグは変わりません。公開前にコンパイルプレビュー上の「変更を取り消す」から元に戻すことができます。
            </Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <HStack spacing="12px">
              <Button ref={cancelRef} onClick={onClose}>
                キャンセル
              </Button>
              <Button colorScheme="red" onClick={handleConfirm}>
                削除
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
